module.exports = __webpack_public_path__ + "img/TBWTTNL_cards-fit.b30ce681.jpg";